import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './Slider.css'

var SimpleSlider = React.createClass({

  componentWillMount(){
      var wrapper = document.getElementById("slider-elements")
      var content = Array.prototype.slice.call(wrapper.children)
      this.setState({
        content: content
      })
  },

  render: function () {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: this.state.content.length > 1,
      draggable: this.state.content.length > 1
    };
    return (
      this.state.content.length > 0 ?
        <Slider {...settings}>
          {this.state.content.map((item, idx)=><div
            key={"slider-img-"+idx}
            dangerouslySetInnerHTML={{__html: item.outerHTML}}/>)}
        </Slider>
      : null

    );
  }
});

export default SimpleSlider



// WEBPACK FOOTER //
// ./src/Slider.js